import ContactUs from 'components/ContactUs/ContactUs';
import React from 'react';
import { useNavigate } from 'react-router';

export default function ContactUsPage() {
	const navigate = useNavigate();

	return <ContactUs onClose={() => navigate(-1)} />;
}
